module.exports = __webpack_public_path__ + "static/img/8.4601897.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/sp/8.png
// module id = CvEY
// module chunks = 0